import { Region, City, Clan, Player, Update, Mod, BlogPost, GalleryItem, Rule, ServerStats, OnboardingConfig, Route, ServerRecord, LibraryConfig, SiteLayout, Skin, JourneyPath } from '../types';

// Estatísticas do Servidor - O administrador pode atualizar via Site Settings
export const serverStats: ServerStats = {
  activePlayers: "0",
  totalRegions: 0,
  registeredClans: 0,
  historyDays: 0
};

export const regions: Region[] = [];
export const cities: City[] = [];

// Clãs - Gerenciar via Admin > Clãs
export const clans: Clan[] = [];

// Jogadores - Gerenciar via Admin > Lenda
export const players: Player[] = [];

// Atualizações - Gerenciar via Admin > Updates
export const updates: Update[] = [];

// Mods - Gerenciar via Admin > Mods
export const mods: Mod[] = [];

// Blog Posts - Gerenciar via Admin > Content
export const blogPosts: BlogPost[] = [];

// Galeria - Gerenciar via Admin > Gallery
export const gallery: GalleryItem[] = [];

// Skins - Gerenciar via Admin > Skins
export const skins: Skin[] = [
  { 
    id: 's1', 
    name: 'Traje de Explorador Arcano', 
    category: 'Aventura', 
    rarity: 'Épico', 
    author: 'Admin', 
    imageUrl: '/images/gallery/exploration_01.svg',
    order: 1 
  },
  { 
    id: 's2', 
    name: 'Armadura de Cavaleiro do Vazio', 
    category: 'Combate', 
    rarity: 'Lendário', 
    author: 'Equipe Hytale', 
    imageUrl: '/images/gallery/landscape_01.svg',
    order: 2 
  },
  { 
    id: 's3', 
    name: 'Túnica de Mestre Alquimista', 
    category: 'Cosmético', 
    rarity: 'Raro', 
    author: 'Comunidade', 
    imageUrl: '/images/gallery/exploration_01.svg',
    order: 3 
  }
];

// Configuração da Biblioteca - Controle Central da Documentação
export const libraryConfig: LibraryConfig = {
  sections: {
    mods: { enabled: false, title: 'MODS', subtitle: 'Modificações e sistemas ativos no servidor.', icon: 'Shield', order: 1 },
    skins: { enabled: true, title: 'SKINS', subtitle: 'Catálogo de personalização visual e cosméticos.', icon: 'Palette', order: 2 },
    rules: { enabled: true, title: 'REGRAS DO SERVIDOR', subtitle: 'Diretrizes oficiais e código de conduta.', icon: 'Gavel', order: 3 },
  },
  galleryCategories: ['Screenshot', 'Arte', 'Vídeo', 'GIF', 'Arquivo'],
  galleryTypes: ['Screenshot', 'Arte', 'Vídeo', 'GIF', 'Arquivo'],
  globalWarning: {
    enabled: true,
    text: 'O desconhecimento das regras não isenta de punição.',
  },
  theme: 'Dark',
  animationsEnabled: true,
};

// Configuração de Onboarding - Gerenciar via Admin > Onboarding
export const onboardingConfig: OnboardingConfig = {
  recommendedRegionSlug: '',
  autoMode: true,
  customMessage: 'Configure a região inicial recomendada no painel admin.',
  ctaText: 'Explorar Região',
  highlightImageUrl: '',
  highlightVideoUrl: '/onboarding_video.mp4'
};

// Regras - Gerenciar via Admin > Rules
export const rules: Rule[] = [];

// Recordes/Conquistas - Gerenciar via Admin > Records
export const records: ServerRecord[] = [];

// Jornadas de Onboarding - Gerenciar via Admin > Onboarding (ou novo manager)
export const paths: JourneyPath[] = [
  {
    slug: 'explorador',
    name: 'Explorador',
    description: 'Descubra biomas únicos, ruínas antigas e segredos escondidos nos cantos mais remotos de Orbis.',
    icon: 'Compass',
    isActive: true,
    order: 1,
    progressionType: 'Exploração',
    ctaText: 'Iniciar Jornada'
  },
  {
    slug: 'guerreiro',
    name: 'Guerreiro',
    description: 'Domine a arte do combate, proteja seu clã e enfrente as criaturas mais perigosas das Profundezas.',
    icon: 'Shield',
    isActive: true,
    order: 2,
    progressionType: 'Combate',
    ctaText: 'Escolher Destino'
  },
  {
    slug: 'construtor',
    name: 'Construtor',
    description: 'Erga cidades monumentais, fortalezas impenetráveis e deixe sua marca eterna na arquitetura do servidor.',
    icon: 'Hammer',
    isActive: true,
    order: 3,
    progressionType: 'Construção',
    ctaText: 'Começar Obra'
  },
  {
    slug: 'comerciante',
    name: 'Comerciante',
    description: 'Domine a economia, estabeleça rotas comerciais e transforme moedas em poder e influência.',
    icon: 'Coins',
    isActive: true,
    order: 4,
    progressionType: 'Economia',
    ctaText: 'Abrir Negócio'
  }
];

export const routes: Route[] = [];

// Layout Inicial do Site - Gerenciável via CMS Visual
export const siteLayout: SiteLayout = {
  pages: {
    '/': {
      theme: 'Dark',
      sections: [
        { id: 'hero-1', type: 'hero', title: 'Domine as Terras Arcanas', isVisible: true, order: 1, config: {} },
        { id: 'stats-1', type: 'stats', title: 'O Mundo em Números', isVisible: true, order: 2, config: {} },
        { id: 'grid-1', type: 'grid', title: 'Recursos Exclusivos', isVisible: true, order: 3, config: { columns: 3 } },
      ]
    }
  }
};